import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import * as icons from 'mdi-material-ui';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    alertIconDefault: {
        fontSize: 16,
        verticalAlign: 'baseline',
        color: theme.palette.grey[400],
        marginLeft: 15,
    },
    alertIconCompleted: {
        color: theme.constants.colorSuccess,
    },
    alertIconSignature: {
        color: theme.constants.colorWarning,
    },
    alertIconValidation: {
        color: theme.palette.grey[400],
    },
}));

const DistributorAlertCircle = props => {
    const { status } = props;
    const classes = useStyles();

    return (
        <icons.Circle
            className={clsx({
                [classes.alertIconDefault]: true,
                [classes.alertIconValidation]: status === 'pending_validation',
                [classes.alertIconSignature]: status === 'pending_signature',
                [classes.alertIconCompleted]: status === 'completed',
            })}
        />
    );
};

DistributorAlertCircle.propTypes = {
    status: PropTypes.string.isRequired,
};

export default DistributorAlertCircle;
